import React, { useEffect, useMemo, useState } from 'react'
import { Col, DatePicker, Input, Row, Select, Space, AutoComplete } from 'antd'
import moment from 'moment'
import { useLocation, useHistory } from 'react-router-dom'
import queryString from 'query-string'
import { inject, observer } from 'mobx-react'

const { RangePicker } = DatePicker
const { Option } = Select

const AdvanceFilterBlockBoardReport = ({ boardReportStore, userList }) => {
  const location = useLocation()
  const history = useHistory()
  const query = queryString.parse(location.search)

  const updateQueryParams = (params = {}) => {
    const newQueryParams = {
      page: 0,
      size: 10,
      ...params,
    }

    Object.keys(newQueryParams).forEach(key => {
      if (newQueryParams[key] === undefined || newQueryParams[key] === null) {
        delete newQueryParams[key]
      }
    })

    boardReportStore.setQueryParams(newQueryParams)

    const newQueryString = queryString.stringify(newQueryParams, {
      skipNull: true,
      skipEmptyString: true,
    })

    history.replace(`/board-report?${newQueryString}`)
  }

  // useEffect(() => {
  //   boardReportStore.clearQueryParams()
  //   history.replace('/board-report')
  //   boardReportStore.getBoardReportList()
  // }, [])

  const handleSearchField = (field, value) => {
    const cleanQuery = { ...query }
    delete cleanQuery.page

    updateQueryParams({
      ...cleanQuery,
      [field]: value?.trim() || undefined,
    })
  }

  const handleChangeDateRange = dates => {
    const cleanQuery = { ...query }
    delete cleanQuery.page

    const from = dates?.[0]?.format('YYYY-MM-DD')
    const to = dates?.[1]?.format('YYYY-MM-DD')

    updateQueryParams({
      ...cleanQuery,
      createdAtFrom: from || undefined,
      createdAtTo: to || undefined,
    })
  }

  const handleChangeUserCreated = searchValue => {
    const cleanQuery = { ...query }
    delete cleanQuery.page

    updateQueryParams({
      ...cleanQuery,
      userCreated: searchValue?.trim() || undefined,
    })
  }

  return (
    <Row gutter={16}>
      <Col span={6}>
        <Space direction="vertical" style={{ width: '100%', marginBottom: 10 }}>
          <label>Tiêu đề</label>
          <Input.Search
            placeholder="Nhập tiêu đề báo cáo"
            allowClear
            defaultValue={query.title ? query.title : ''}
            onSearch={value => handleSearchField('title', value)}
          />
        </Space>
      </Col>
      <Col span={6}>
        <Space direction="vertical" style={{ width: '100%', marginBottom: 10 }}>
          <label>Người tạo</label>
          <Input.Search
            placeholder="Nhập tên người tạo"
            allowClear
            defaultValue={query.userCreated ? query.userCreated : ''}
            onSearch={value => handleChangeUserCreated(value)}
          />
        </Space>
      </Col>
      <Col span={6}>
        <Space direction="vertical" style={{ width: '100%', marginBottom: 10 }}>
          <label>Ngày tạo</label>
          <RangePicker
            style={{ width: '100%' }}
            format="DD/MM/YYYY"
            allowClear
            defaultValue={[
              query.createdAtFrom
                ? moment(query.createdAtFrom, 'YYYY-MM-DD')
                : null,
              query.createdAtTo
                ? moment(query.createdAtTo, 'YYYY-MM-DD')
                : null,
            ]}
            onChange={handleChangeDateRange}
          />
        </Space>
      </Col>
    </Row>
  )
}

export default inject(
  'boardReportStore',
  'userStore'
)(observer(AdvanceFilterBlockBoardReport))
